<template>
<div class="mobile-preview-super-wrapper">
    <div class="mobile-preview-wrapper"  :class="{active: clientWidth>500}"  :style="style">
        <SiteSearchFrame v-if="clientWidth>=500" :config="config" :width="width" :height="height" :demo="demo" :is-visible="isVisible" :is-mobile="true" :padding-top="htmlPaddingTop"  :content-img="contentImg" :header-img="headerImg"  />
        <span v-else>{{texts.preview.mobileUnavailable}}</span>
    </div>
</div>
</template>

<script>
import SiteSearchFrame from "./SiteSearchFrame";
import Vue from "vue";
export default {
  name: "DesktopPreview",
  components: { SiteSearchFrame },
  props: {
    config: {
      type: Object,
      required: true
    },
    demo: String,
    isVisible: Boolean
  },
  data() {
    return {
      width: 480,
      height: 854,
      clientWidth: document.documentElement.clientWidth,
      htmlPaddingTop: 99
    };
  },
  computed: {
    style() {
      return {
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% auto",
        paddingRight: "10px",
        paddingLeft: "10px",
        maxWidth: "480px",
        paddingTop: "57px",
        paddingBottom: "57px"
      };
    },
    contentImg(){
      return require("../../assets/mobile_browser_content.svg");
    },
    headerImg(){
      return "https://cdn2.hubspot.net/hubfs/3826488/Website/Visual%20Configurator/mobile_browser_ui.eb0cad0.png"; //require("../../assets/mobile_browser_ui.png");
    }
    // ,
    // cursorImg(){
    //   return require("../../assets/mobile_cursor.svg");
    // }
  }
};
</script>

<style>

.mobile-preview-super-wrapper{
  width: 100%;
  display: flex;
  justify-content: center;
}

.mobile-preview-wrapper {
	box-sizing: content-box;
}

.mobile-preview-wrapper.active {
  background: url("../../assets/mobile_background.svg");
}

.mobile-preview-wrapper.active iframe{
      background: url('https://cdn2.hubspot.net/hubfs/3826488/Website/Visual%20Configurator/mobile_browser_ui.eb0cad0.png');
      background-repeat: no-repeat;
      background-position: 0 0;
      background-size: 100% auto;
      /* cursor: url('../../assets/mobile_cursor.svg'), auto; */
}
</style>


// WEBPACK FOOTER //
// src/components/preview/MobilePreview.vue